import { ShippingAddressValuesForm } from '@components/AccumulatedCampaignManagement/type';
import dataAddresses from '@components/Checkout/Sprites/data_address.json';

import { isBrowser } from './isBrowser';

export const removeSpaces = (s: string): string => {
  return s.replace(/\s/g, '');
};

export const isUat: boolean = isBrowser && window.location.host.includes('uat');

export const sumArray = (arr: number[]): number => {
  return arr.reduce((acc, val) => acc + val, 0);
};

export function generateId() {
  return Math.random().toString(36).slice(2, 9);
}

export function renderFestivalClassName(
  festival: string,
  classNamesMap: Record<string, string>,
  defaultClassName?: string,
) {
  return classNamesMap[festival] || defaultClassName || '';
}

export function buildShippingAddress(values: ShippingAddressValuesForm) {
  const province = dataAddresses.find((item: any) => item?.id === values.province);
  const district = province?.districts.find((item: any) => item?.id === values.district);
  const ward = district?.wards.find((item: any) => item?.id === values.ward);

  return `${values.address}, ${ward?.name || ''}, ${district?.name || ''}, ${province?.name || ''}`;
}

export function mergeObjIgnoringUndefinedAndNull(obj1: object, obj2: object) {
  const filteredObj1 = Object.fromEntries(Object.entries(obj1).filter(([, value]) => value != null));
  const filteredObj2 = Object.fromEntries(Object.entries(obj2).filter(([, value]) => value != null));
  return { ...filteredObj1, ...filteredObj2 };
}

export function getCartFilter(callback: (input: string) => string): { key: string; name: string }[] {
  return [
    {
      key: 'all',
      name: callback('all'),
    },
    {
      key: 'order_items',
      name: callback('product_list'),
    },
    {
      key: 'gifts',
      name: callback('gift_list'),
    },
    {
      key: 'vat8',
      name: callback('vat8'),
    },
    {
      key: 'vat10',
      name: callback('vat10'),
    },
  ];
}
